import { render, staticRenderFns } from "./hotelOrderXq.vue?vue&type=template&id=20560a02&scoped=true"
import script from "./hotelOrderXq.vue?vue&type=script&lang=js"
export * from "./hotelOrderXq.vue?vue&type=script&lang=js"
import style0 from "./hotelOrderXq.vue?vue&type=style&index=0&id=20560a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20560a02",
  null
  
)

export default component.exports